<div id="dragDiv"
     #draggableDiv
     class="draggable resize overlay-borde-firma"
     [ngStyle]="boxStyle">
      <svg #draggableIcon class="icon-draggable">
        <use xlink:href="#icon-draggable"></use>
       </svg>
       <svg class="icon-close" (click)="borrarCampo()">
        <use xlink:href="#icon-close"></use>
       </svg>
     <div id="resizeDiv" class="pinta"></div>
</div>
